module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-window"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "white",
      "padding-right": "100px"
    }
  }, [(!_vm.isLogin) ? _c('a', {
    staticStyle: {
      "border-right": "2px solid white",
      "padding-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.setshow()
      }
    }
  }, [_vm._v("登录")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "href": "http://q.940177.com",
      "target": "_blank"
    }
  }, [_vm._v("下载APP")])])]), _vm._v(" "), _c('transition', [_c('router-view')], 1), _vm._v(" "), _c('fullscreen-img'), _vm._v(" "), _c('loading'), _vm._v(" "), _c('tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "vux-demo-tabbar",
    attrs: {
      "slot": "bottom",
      "icon-class": "vux-center"
    },
    slot: "bottom"
  }, [_c('tabbar-item', {
    attrs: {
      "link": {
        path: '/'
      },
      "selected": this.$route.path === '/'
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("./assets/discover_normal.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "icon-active",
      "src": require("./assets/discover_actived.png")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    staticClass: "actived_text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("发现")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "badge": _vm.sysMsgUnread,
      "link": {
        name: 'session'
      },
      "selected": this.$route.path === '/session'
    },
    on: {
      "on-item-click": _vm.clear
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("./assets/msg.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "icon-active",
      "src": require("./assets/msg_actived.png")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    staticClass: "actived_text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("消息")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": {
        name: 'my'
      },
      "selected": this.$route.path === '/my'
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("./assets/me.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "slot": "icon-active",
      "src": require("./assets/me_actived.png")
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    staticClass: "actived_text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("我的")])])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "showlogindialog": _vm.showLoginDialog
    },
    on: {
      "hidedialog": _vm.hidedialog
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.taluo.com"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "height": "30px"
    },
    attrs: {
      "src": require("./assets/header.png")
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a1eebe0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1eebe0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 383
// module chunks = 26